import type { ClubPlayer } from "@mixitone/models";
import type { List } from "@mixitone/oom";
import { keyBy } from "@mixitone/util";
import type { ResourceListOptions } from "services/AgentToolsService";
import { clubPlayerLastPlayed } from "./reporting";

export function needsClubPlayerFirstSessionDate(options?: ResourceListOptions): boolean {
  if (!options) return false;
  if (options.fields?.includes("firstSessionDate")) return true;
  return options.filter != null && "firstSessionDate" in options.filter;
}

/** Preload first session dates onto club player models for derived getters and agent queries. */
export async function injectClubPlayerSessionDates(
  clubId: string,
  clubPlayers: List<ClubPlayer> | ClubPlayer[],
): Promise<void> {
  if (clubPlayers.length === 0) return;

  const { clubPlayersLastPlayed } = await clubPlayerLastPlayed({ clubId });
  const byId = keyBy(clubPlayersLastPlayed, "club_player_id");

  for (const player of clubPlayers) {
    const row = byId[player.id!];
    if (row?.date_of_first_night_played) {
      player.data.set("first_session_date", row.date_of_first_night_played);
    }
  }
}
